/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DurationInputs */

const en_duration = /** @type {(inputs: DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const es_duration = /** @type {(inputs: DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duracion`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {DurationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const duration = /** @type {((inputs?: DurationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DurationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duration(inputs)
	return es_duration(inputs)
});